var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "term" },
    [
      _c("h2", [
        _vm._v(_vm._s(_vm.$t("MAIN_CONTENT.commonContent.newEntryTitleCase")))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", { attrs: { for: "term-new" } }, [
          _vm._v(_vm._s(_vm.$t("MAIN_CONTENT.commonContent.term")))
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.editingTerm.TERM,
              expression: "editingTerm.TERM"
            }
          ],
          staticClass: "form-control",
          attrs: { id: "term-new", type: "text" },
          domProps: { value: _vm.editingTerm.TERM },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.editingTerm, "TERM", $event.target.value)
            }
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("label", { attrs: { for: "definition-new" } }, [
            _vm._v(_vm._s(_vm.$t("MAIN_CONTENT.commonContent.definition")))
          ]),
          _vm._v(" "),
          _c("ckeditor4", {
            attrs: { editor: _vm.editor, config: _vm.editorConfig },
            model: {
              value: _vm.editingTerm.DEFINITION,
              callback: function($$v) {
                _vm.$set(_vm.editingTerm, "DEFINITION", $$v)
              },
              expression: "editingTerm.DEFINITION"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      !!_vm.$route.params.courseSectionGUID &&
      !!_vm.selectedStudent.STUDENT_RID &&
      !!_vm.$store.state.accessToken &&
      !!_vm.$store.state.clientID
        ? [
            _c("file-uploader", {
              ref: "fileUpload",
              attrs: {
                nameHeader: _vm.$t("MAIN_CONTENT.commonContent.name"),
                sizeHeader: _vm.$t("MAIN_CONTENT.commonContent.size"),
                removeHeader: _vm.$t("MAIN_CONTENT.commonContent.remove"),
                dropSingleFile: _vm.$t(
                  "MAIN_CONTENT.commonContent.dropSingleFile"
                ),
                dropMultipleFiles: _vm.$t(
                  "MAIN_CONTENT.commonContent.dropMultipleFiles"
                ),
                selectSingleFile: _vm.$t(
                  "MAIN_CONTENT.commonContent.selectSingleFile"
                ),
                selectMultipleFiles: _vm.$t(
                  "MAIN_CONTENT.commonContent.selectMultipleFiles"
                ),
                attachFile: _vm.$t("MAIN_CONTENT.commonContent.attachFile"),
                attachFiles: _vm.$t("MAIN_CONTENT.commonContent.attachFiles"),
                files: _vm.files,
                postAction: _vm.fileUploadToken,
                URL: _vm.externalFileData
              },
              on: {
                saveGoogleFilesData: _vm.saveGoogleFileData,
                saveDropboxFilesData: _vm.saveDropboxFileData,
                saveOneDriveFilesData: _vm.saveOneDriveFileData,
                updateFiles: _vm.updateValue
              }
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "form-group text-right" }, [
        _c(
          "button",
          { staticClass: "btn btn-default", on: { click: _vm.closeForm } },
          [_vm._v(_vm._s(_vm.$t("commonText.cancel")))]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-success",
            attrs: { disabled: !_vm.editingTerm.TERM },
            on: { click: _vm.save }
          },
          [_vm._v(_vm._s(_vm.$t("commonText.save")))]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }